import type { DiscountTargetType } from "@/lib/gql/__generated__/graphql";
import { DiscountTermType, DiscountType } from "@/lib/gql/__generated__/graphql";

import type { Ordinary } from "..";
import type { RowData } from "../../../discount-table";

import { discountTargetTypeConverter, omittedPriceSettingConverter } from ".";

const StaticTermTypeMap = {
	[DiscountTermType.PerDate]: "1日ごとに",
	[DiscountTermType.PerReservation]: "予約を通して",
} as const;

/**
 * DiscountType = Ratio の PriceSetting へのデータ変換
 */
const discountTypeRatioForPriceSettingConverter = (ratio: number) => `宿泊料金から${ratio}%割引`;
/**
 * DiscountType = Static の PriceSetting へのデータ変換
 */
const discountTypeStaticForPriceSettingConverter = (
	staticPrice: number,
	staticTargetType?: DiscountTargetType,
	staticTermType?: DiscountTermType,
) => {
	const staticTargetTypeDisplayText = discountTargetTypeConverter(staticTargetType);
	const staticTermTypeDisplayText = staticTermType ? StaticTermTypeMap[staticTermType] : "";
	return `宿泊料金から${staticTargetTypeDisplayText}ごとに${staticTermTypeDisplayText}${staticPrice.toLocaleString()}円引き`;
};

/**
 * OrdinaryDiscount の行データを生成する
 */
export const ordinaryRowsDataConverter = (ordinaryList: Ordinary) => {
	return ordinaryList.map((discount) => {
		const discountPriceTotalLimitAmount = discount.discountPriceTotalLimit?.amount ?? undefined;
		const convertedOmittedPriceSetting = omittedPriceSettingConverter(
			discount.discountID,
			discount.name,
			discount.discountCode,
			discount.discountPriceTotal.amount,
			discount.inSale,
			discountPriceTotalLimitAmount,
		);
		const discountRatio = discount.ratio ?? 0;
		const staticAmount = discount.static?.amount ?? 0;
		const staticTargetType = discount.staticTargetType ?? undefined;
		const staticTermType = discount.staticTermType ?? undefined;
		const convertedPriceSetting =
			discount.discountType === DiscountType.Ratio
				? discountTypeRatioForPriceSettingConverter(discountRatio)
				: discountTypeStaticForPriceSettingConverter(staticAmount, staticTargetType, staticTermType);

		return {
			...convertedOmittedPriceSetting,
			priceSetting: convertedPriceSetting,
		};
	}) satisfies Array<RowData>;
};
